module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-container"
  }, [_c('svg', {
    attrs: {
      "viewBox": "114 105 968 778",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Path-6",
      "stroke": "#979797",
      "stroke-width": "1",
      "fill": "#FFFFFF",
      "fill-rule": "evenodd",
      "points": "601.439453 881.119141 114.996094 105.890625 1081.02344 107.375"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "logo",
    attrs: {
      "d": "M1024.89062,153.914063 L614.148438,380.488281 L614,791.59375 L614.148438,821 L1024.89062,153.914063 Z M1008.5,131.990947 L601.484375,361 L183.117188,130.09375 L1008.5,131.990947 Z M589.488281,821.699219 L588.613083,381 L176.785156,158.660156 L589.488281,821.699219 Z",
      "id": "Combined-Shape",
      "stroke": "#979797",
      "stroke-width": "1",
      "fill": "#B2DFDB",
      "fill-rule": "evenodd"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d7e02a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logo.vue
// module id = 84
// module chunks = 1